import "../../App.css";
import Sidebar from "../../components/Sidebar";
import "../../styles/login.css";
import { withRouter } from "react-router-dom";
import React, { useState, useEffect } from "react";
import Table from "../Table";
import UserTab from "../UserTab";
import Parametros from "../Parametros";
import CurrentUser from "../CurrentUser";
import EliminarElemento from "../EliminarElemento";
function Relaciones(props) {
  const { history } = props;
  const [RelacionesStateUpdate, setRelacionesStateUpdate] = useState([]);
  const [RelacionesState, setRelacionesState] = useState([]);
  // eslint-disable-next-line
  const [usuario, setUsuario] = useState(CurrentUser.user);
  const [formularioUpdate, setformularioUpdate] = useState({});
  const [update, setUpdate] = useState(true);
  const [paginacionState, setPaginacionState] = useState({
    limit: 5,
    skip: 1,
  });
  useEffect(() => {
    async function llamadaApi() {
      let response = await fetch(
        Parametros.urlApi + "relationships/?skip=0&limit=100",
        {
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        let responseJson = await response.json();

        let responseJsonUpdate = JSON.stringify(responseJson);
        let responseJsonstate = JSON.stringify(responseJson);
        setRelacionesState(JSON.parse(responseJsonUpdate));
        setRelacionesStateUpdate(JSON.parse(responseJsonstate));
      } else if (response.status === Parametros.loginTokenExcept) {
        alert(Parametros.loginTokenExceptMessage);
        history.push({
          pathname: "/",
        });
      }
    }
    llamadaApi();
  }, [update, usuario, history]);
  const [formularioState, setFormularioState] = useState({
    name: "",
  });
  const [editable, setEditable] = useState({
    id: "",
  });
  let handleStageForm = (event) => {
    setFormularioState({
      ...formularioState,
      [event.target.name]: event.target.value,
    });
  };
  let crearRelaciones = async (event) => {
    event.preventDefault();
    if (usuario.permisos.indexOf("Crear") > -1) {
      if (window.confirm("¿Esta seguro que deseas agregar este elemento?")) {
        let response = await fetch(Parametros.urlApi + "relationships/", {
          method: "POST",
          body: JSON.stringify(formularioState),
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        });
        let responseJson = await response.json();

        if (response.status === 200 || response.status === 201) {
          setUpdate(!update);
          alert("ok");
          document.getElementById("formularioBusqueda").reset();
        } else if (response.status === Parametros.loginTokenExcept) {
          alert(Parametros.loginTokenExceptMessage);
          history.push({
            pathname: "/",
          });
        } else {
          setUpdate(!update);
          alert(responseJson.detail);
        }
      } else {
        // Do nothing!
        setEditable({});
        // setpersonaEmpresaState(JSON.parse(JSON.stringify(personaEmpresaStateUpdate)))
      }
    } else {
      alert(usuario.crear);
    }
  };

  let RelacionesHandleChange = (index, e) => {
    const name = e.target.getAttribute("name");
    const value = e.currentTarget.value
      ? e.currentTarget.value
      : e.currentTarget.innerText;

    let newList = RelacionesState;
    newList[index][name] = value;
    setRelacionesState(JSON.parse(JSON.stringify(newList)));

    let estadoUpdate = formularioUpdate;
    estadoUpdate[name] = value;

    setformularioUpdate(JSON.parse(JSON.stringify(estadoUpdate)));
  };
  let confirmarEdicion = async (item) => {
    // setetapaStateUpdate(nuevoObjeto)
    if (usuario.permisos.indexOf("Editar") > -1) {
      if (window.confirm("¿Esta seguro que deseas editar este elemento?")) {
        let response = await fetch(
          Parametros.post + "relationships/" + item.relationship_id,
          {
            method: "PUT",
            headers: {
              Authorization: "Bearer " + usuario.key,
              Accept: "application/json",
              "Content-Type": "application/json",
              Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
            },
            body: JSON.stringify(formularioUpdate),
          }
        );

        let responseJson = await response.json();

        if (response.status === 200 || response.status === 201) {
          setEditable({});
          setUpdate(!update);
          alert("ok");
        } else if (response.status === Parametros.loginTokenExcept) {
          alert(Parametros.loginTokenExceptMessage);
          history.push({
            pathname: "/",
          });
        } else {
          alert(responseJson.detail);
          setUpdate(!update);
          setEditable({});
        }
      } else {
        // Do nothing!
        setEditable({});
      }
    } else {
      alert(usuario.editar);
    }
  };

  let editar = (id) => {
    setRelacionesState(JSON.parse(JSON.stringify(RelacionesStateUpdate)));
    setEditable(id);
    setformularioUpdate({});
  };
  let cancelarEdicion = async (item) => {
    setEditable({});
    setRelacionesState(JSON.parse(JSON.stringify(RelacionesStateUpdate)));
  };

  return (
    <div className="App">
      <Sidebar tipo="2"></Sidebar>
      <br />
      <div className="container">
        <UserTab nombre={"Relaciones"}></UserTab>
        <form id="formularioBusqueda" onSubmit={crearRelaciones}>
          <div className="col-md-4">
            <h5>Nombre Relaciones</h5>
            <input
              onChange={handleStageForm}
              name="name"
              required
              className="form-control"
            ></input>
          </div>

          <div className="col-md-4">
            <br />
            <button
              type="submit"
              value="Submit"
              style={{ margin: "14px 0px" }}
              id="btnBuscar"
              className="form-control button brEdit btn-primary"
            >
              Agregar nuevo
            </button>
          </div>
        </form>

        <div
          className="col-md-12 table-responsive"
          style={{ height: 300, width: "100%" }}
        >
          <Table
            type={1}
            paginationBelow={true}
            paginas={Math.max(
              1,
              Math.ceil(RelacionesState.length / paginacionState.limit)
            )}
            paginadorState={paginacionState}
            setPaginadoor={setPaginacionState}
            elementos={["Nombre Relaciones"]}
          ></Table>
          <table className="table table-bordered" id="myTable">
            <Table type={2} elementos={["Nombre Relaciones"]}></Table>
            {usuario.permisos.indexOf("Ver") > -1 ? (
              <tbody className="ajusteTabladata">
                {RelacionesState.slice(
                  (paginacionState.skip - 1) * paginacionState.limit,
                  (paginacionState.skip - 1) * paginacionState.limit +
                    paginacionState.limit
                ).map((item, displayIndex) => {
                  const index =
                    (paginacionState.skip - 1) * paginacionState.limit +
                    displayIndex;
                  return (
                    <tr key={item.relationship_id}>
                      {editable === item.relationship_id ? (
                        <>
                          <td>{item.relationship_id}</td>
                          <td>
                            <input
                              value={item.name}
                              name="name"
                              onChange={(event) => {
                                RelacionesHandleChange(index, event);
                              }}
                              className="form-control"
                            ></input>
                          </td>
                          <td>
                            <abbr title="Confirmar Edición">
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  confirmarEdicion(item);
                                }}
                                className="glyphicon glyphicon glyphicon-ok"
                              >
                                {" "}
                              </span>
                            </abbr>
                            <abbr title="Cancelar Edición">
                              {" "}
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  cancelarEdicion(item);
                                }}
                                className="glyphicon glyphicon-share-alt"
                              ></span>
                            </abbr>
                          </td>
                        </>
                      ) : (
                        <>
                          <td>{item.relationship_id}</td>
                          <td>{item.name} </td>
                          <td>
                            <abbr title="Editar Elemento">
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  editar(item.relationship_id);
                                }}
                                className="glyphicon glyphicon-pencil"
                              >
                                {" "}
                              </span>
                            </abbr>
                            <EliminarElemento
                              endpoint={`relationships/${item.relationship_id}`}
                              onSuccess={() => {
                                setUpdate(!update);
                              }}
                            />
                          </td>
                        </>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            ) : (
              <tbody>
                <td>{usuario.ver}</td>
              </tbody>
            )}
          </table>
          <Table
            type={3}
            paginas={Math.max(
              1,
              Math.ceil(RelacionesState.length / paginacionState.limit)
            )}
            paginadorState={paginacionState}
            setPaginadoor={setPaginacionState}
          />
          {!usuario.permisos.indexOf("Ver") < -1 && usuario.ver}
        </div>
      </div>
    </div>
  );
}

export default withRouter(Relaciones);
